import Debug from 'debug'
import Vue from "vue";
import * as Sentry from '@sentry/vue'
import { resolveVersion, VersionInfo } from '@/app/version'

const debug = Debug('error-reporting')

type Options = {
  environment: string
  allowOnlyFromHosts: string[]
  dsn: string
} & VersionInfo

export function configureErrorReporting() {  
  const options = resolveOptions()

  if (options.environment !== 'production') {
    debug(`current mode is '${options.environment}' -> error reporting is disabled`)
    return
  }

  if (options.allowOnlyFromHosts.length === 0) {
    debug(`'allowOnlyFromHosts' is not set -> error reporting is disabled`)
    return
  }

  let hostname = window.location.hostname
  if (!hostname ||
        !allowHost(hostname, options.allowOnlyFromHosts)) {
    // we currently allow bug tracking only from neting
    debug(`current host name '${hostname}' does not allowed by ` +
          `'${options.allowOnlyFromHosts}' -> error reporting is disabled`)
    return
  }
  
  debug(`enabling error reporting for release '${options.release}' with options`, options)

  Sentry.init({
    Vue: Vue,
    dsn: options.dsn,
    release: options.release,
    environment: options.environment,
    allowUrls: options.allowOnlyFromHosts,
    beforeSend: (event, hint) => {
      debug(`sending error report`, event, hint)
      if (!event.exception?.values) {
        return event
      }

      const value = event.exception.values[0]
      if (!value.stacktrace?.frames) {
        return event
      }

      value.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          const index = frame.filename.indexOf('/js/')
          if (index >= 0) {
            frame.filename = frame.filename.slice(index)
          }
        }

        console.log(frame.filename)
      })

      return event
    },
    autoSessionTracking: false
  })
  Sentry.setTag('git_hash', options.git.hash)
  Sentry.setTag('git_branch', options.git.branch)
  Sentry.setTag('git_tag', options.git.tag)

  function allowHost(host: string, allowedHosts: string[]) {
    for (let allowedHost of allowedHosts) {
      if (host.includes(allowedHost)) {
        return true
      }
    }

    return false
  }
}

function resolveOptions(): Options {
  const env = process.env

  const version = resolveVersion()
  const allowOnlyFromHosts: string = env.VUE_APP_ERROR_REPORTING_ALLOW_ONLY_FROM_HOSTS

  return {
    ...version,
    environment: env.NODE_ENV,
    allowOnlyFromHosts: allowOnlyFromHosts ? allowOnlyFromHosts.split(',') : [],
    dsn: env.VUE_APP_ERROR_REPORTING_DSN
  }
}
